import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type SessionContextService from 'tio-employee/services/session-context';
import type RouterService from '@ember/routing/router-service';
import type CableService from 'tio-common/services/cable';

export default class LogoutRoute extends Route {
  @service declare sessionContext: SessionContextService;
  @service declare router: RouterService;
  @service declare cable: CableService;

  beforeModel() {
    this.cable.disconnect();
    this.sessionContext.logout();
    this.router.transitionTo('/logged-out');
  }
}
